import { inject, Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { catchError, mapTo } from 'rxjs/operators';
import { PersonApi } from '../services';

@Injectable({ providedIn: 'root' })
export class ValidPasswordValidator implements AsyncValidator {
  private personApi = inject(PersonApi);

  public validate(ctrl: AbstractControl, userId: number = -1): Observable<ValidationErrors | null> {
    return this.personApi.validatePasswordStrength(userId, ctrl.value).pipe(
      mapTo(null),
      catchError((err) => {
        const errorContext = err.message.errors[0];

        switch (errorContext.reason) {
          case 'NO_CONTEXT':
            return of({ 'no-context': true });
          case 'NO_USER_INFO':
            return of({ 'no-user-info': true });
          default:
            return of({ 'unknown-error': true });
        }
      })
    );
  }
}
